import { Box } from '@mui/material'
import { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import { useGetAllTransportModesQuery } from '../../../app/redux-fetch/apiCoreQuery'
import FormSelect from '../../../components/Forms/FormSelect'
import { SectionTitleTypography } from '../../../components/Typographies/styles'
import messages from '../messages'

type DefaultValuesProps = {
    isDisabled?: boolean
}

export const DefaultValues = ({ isDisabled = false }: DefaultValuesProps): ReactElement<any, any> => {
    const { data: transportModesResult = [] } = useGetAllTransportModesQuery()
    const { formatMessage } = useIntl()

    const transportModes = transportModesResult.map((mode: any) => ({
        label: mode.name,
        value: mode.id,
    }))

    return (
        <Box sx={{ mb: '16px', width: '75%' }}>
            <Box sx={{ mb: '16px' }}>
                <SectionTitleTypography>{formatMessage(messages.defaultValues)}</SectionTitleTypography>
            </Box>

            <FormSelect
                name="defaultTransportModeId"
                label={formatMessage(messages.transportMode)}
                options={transportModes}
                disabled={isDisabled}
                allowClear
            />
        </Box>
    )
}

export default DefaultValues
